<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="dueDate">Due Date</label>
                    <wj-input-date id="dueDate" [(ngModel)]="target.dueDate" name="dueDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="doneDate">Done Date</label>
                    <wj-input-date id="doneDate" [(ngModel)]="target.doneDate" name="doneDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <div class="form-check">
                        <input
                            id="isRecurring"
                            type="checkbox"
                            class="form-check-input"
                            [(ngModel)]="target.isRecurring"
                            name="isRecurring"
                            (ngModelChange)="onRecurringChange()"
                        />
                        <label class="form-check-label" for="isRecurring">Repeats monthly</label>
                        <fa-icon
                            [icon]="faQuestionCircle"
                            style="margin-left: 5px; cursor: pointer"
                            title="When enabled, a new To-Do is created automatically each month on the chosen week and day, with the same assignee and meeting(s). The previous month's copy is closed out."
                        ></fa-icon>
                    </div>
                </div>
            </div>
        </div>

        @if (target.isRecurring) {
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="recurrenceWeekOfMonth">Week of Month</label>
                        <wj-combo-box
                            id="recurrenceWeekOfMonth"
                            [(ngModel)]="target.recurrenceWeekOfMonth"
                            name="recurrenceWeekOfMonth"
                            [itemsSource]="weekOfMonthList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label for="recurrenceDayOfWeek">Day of Week</label>
                        <wj-combo-box
                            id="recurrenceDayOfWeek"
                            [(ngModel)]="target.recurrenceDayOfWeek"
                            name="recurrenceDayOfWeek"
                            [itemsSource]="dayOfWeekList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">To-Do Task Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="userId">Who</label>
                    @if (isAdding) {
                        <fa-icon
                            [icon]="faQuestionCircle"
                            style="margin-left: 5px; cursor: pointer"
                            title="When adding a new To-Do, multiple users can be selected, and a new To-Do will be created for each user"
                        ></fa-icon>
                    }

                    @if (isAdding) {
                        <wj-multi-select
                            id="userId"
                            name="userId"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [placeholder]="'Select User(s)'"
                            [headerFormat]="'{count:n0} users'"
                            [itemsSource]="userList"
                        >
                        </wj-multi-select>
                    } @else {
                        <wj-combo-box
                            id="userId"
                            [(ngModel)]="target.userId"
                            name="userId"
                            [itemsSource]="userList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    }
                </div>
            </div>
        </div>

        @if (!isUserToDosMode) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="meetings">Associate With Meeting(s)</label>
                        <wj-multi-select
                            name="meetings"
                            [showFilterInput]="true"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [checkedMemberPath]="'$checked'"
                            [headerFormat]="'{count:n0} items'"
                            [itemsSource]="meetingsList"
                            [placeholder]="'No Meeting Association'"
                        >
                        </wj-multi-select>
                    </div>
                </div>
            </div>
        }

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="details">Details</label>
                    <quill-editor
                        #quillEditorRef
                        style="width: 100%"
                        [(ngModel)]="target.details"
                        name="details"
                        [styles]="{ height: '200px' }"
                        [modules]="editorModules"
                    >
                    </quill-editor>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
